import { Turbo } from '@hotwired/turbo-rails';
import TC from '@rolemodel/turbo-confirm';

TC.start({
  dialogSelector: '#turbo-confirm',
  denySelector: '.js-confirm-cancel',
  showConfirmCallback: (element) => {
    element.classList.remove('hidden');
    const panel = element.querySelector('.modal-panel');

    setTimeout(() => {
      panel.classList.remove('opacity-0', 'translate-y-4', 'sm:scale-95');
      panel.classList.add(
        'opacity-100',
        'translate-y-0',
        'sm:scale-100',
        'ease-out-expo',
        'duration-150'
      );
    }, 10); // 10ms delay
  },
  hideConfirmCallback: (element) => {
    const panel = element.querySelector('.modal-panel');

    panel.classList.remove(
      'opacity-100',
      'translate-y-0',
      'sm:scale-100',
      'ease-out-expo',
      'duration-150'
    );
    panel.classList.add(
      'opacity-0',
      'translate-y-4',
      'sm:scale-95',
      'ease-in-expo',
      'duration-150'
    );

    setTimeout(() => {
      element.classList.add('hidden');
    }, 150);
  }
});
